<template>
  <v-container>
    <v-row>
      <v-col v-if="updateErrors.length != 0" cols="12">
        <v-alert v-for="(item, index) in updateErrors" :key="index" dense type="error" outlined text
                 dismissible transition="slide-x-transition" class="py-0 text-uppercase">
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-text-field outlined hide-details="auto" dense label="Stock Code" required disabled
                      :value="stockCode" />
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="barcode" outlined dense hide-details="auto" label="Barcode" clearable />
      </v-col>
      <v-col cols="12">
        <v-autocomplete v-model="stockBrandType" outlined hide-details="auto" dense :loading="stockBrandTypeData.loading"
                        label="Brand Type" :items="stockBrandTypeData.items" item-value="id">
          <template v-slot:selection="{ item }">
            {{ item?.name || 'Select Brand Type' }}
          </template>
          <template v-slot:item="{ item }">
            {{ item.name }}
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="brandName" outlined hide-details="auto" dense label="Brand Name" required />
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="productName" outlined hide-details="auto" dense label="Product Name"
                      required />
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="description" outlined hide-details="auto" dense auto-grow color="teal" rows="1" no-resize>
          <template v-slot:label>
            <div>
              Description <small>(optional)</small>
            </div>
          </template>
        </v-textarea>
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="retail" outlined hide-details="auto" dense label="Retail Price" type="number" required
                      prefix="₱" />
      </v-col>
      <v-col cols="6">
        <v-autocomplete v-model="unit" outlined dense hide-details="auto" item-value="unit" label="Unit"
                        :items="computedUnits">
          <template v-slot:selection="{ item }">
            {{ item.unit }}
          </template>
          <template v-slot:item="{ item }">
            {{ item.unit }} - {{ item.description }}
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2" align-self="end">
        <v-btn color="blue" :loading="updating" @click="initUpdate">
          Save
        </v-btn>
      </v-col>
      <v-col cols="1" align-self="end">
        <v-btn color="red" dark @click="closeDialog">
          Close
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ErrorPopup, useWatchEffect } from '../../../../lib/utils'
import appAxios from '../../../../extra-functions/axios.extra'

function inputVars() {
  return {
    stockCode: null,
    brandName: null,
    barcode: null,
    unit: null,
    retail: null,
    stockBrandType: null,
    productName: null,
    description: null,
  }
}

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'VEditStock',
  props: {
    // propstockCode: String,
    // propStockData: Object,
  },
  data() {
    return {
      id: null,
      ...inputVars(),
      stockBrandTypeData: {
        loading: false,
        items: [],
      },
    }
  },
  computed: {
    ...mapState({
      updateSuccess: state => state.stock.updateSuccess,
      updating: state => state.stock.updating,
      updateErrors: state => state.stock.updateErrors,
      units: state => state.unit.allList,
      authToken: state => state.auth.token,
    }),
    // stockCode () {
    //   return this.propstockCode
    // },
    computedUnits() {
      return this.units.map(e => {
        return {
          ...e,
          displayText: `${e.unit} - ${e.description}`,
        }
      })
    },
  },
  watch: {
    updateSuccess(val) {
      if (val) {
        this.closeDialog()
      }
    },
  },
  created() {
    this.getStockBrandTypes()
  },
  beforeDestroy() {
    console.log('stock edit beforeDestroy')
    clearWatchEffect()
  },
  methods: {
    ...mapActions({
      update: 'stock/update',
    }),
    closeDialog() {
      this.$emit('close-dialog')
    },
    populateInput(data) {
      this.id = data.id
      this.stockCode = data.stock_code
      this.brandName = data.brand_name
      this.unit = data.unit
      this.retail = data.retail
      this.productName = data.product_name
      this.description = data.description
      this.stockBrandType = data.stock_brand_type
      this.barcode = data.barcode
    },
    initUpdate() {
      const data = {
        stock_code: this.stockCode,
        brand_name: this.brandName,
        unit: this.unit,
        retail: this.retail,
        product_name: this.productName,
        description: this.description,
        stock_brand_type: this.stockBrandType,
        barcode: this.barcode,
      }
      this.update({ id: this.id, data })
    },
    getStockBrandTypes(retries = 0) {
      watchEffect(async (onCleanup) => {
        try {
          this.stockBrandTypeData = {
            ...this.stockBrandTypeData,
            loading: true,
          }
          const controller = new AbortController()
          onCleanup(() => {
            controller.abort()
          })
          const axios = appAxios(this.authToken)
          const { data } = await axios.get('/stock-brand-types', {
            signal: controller.signal,
          })
          this.stockBrandTypeData = {
            ...this.stockBrandTypeData,
            items: data,
          }
        } catch (e) {
          console.error(e)
          if (retries >= 5) {
            ErrorPopup.fire({ text: 'Oops something went wrong fetching brand types failed to reconnect 5 times!!!' })
            return
          }
          ErrorPopup.fire({ text: 'Oops something went wrong fetching brand types retrying in 5 secs!!!' })
          setTimeout(() => {
            this.getStockBrandTypes(retries + 1)
          }, 5000)
        } finally {
          this.stockBrandTypeData = {
            ...this.stockBrandTypeData,
            loading: false,
          }
        }
      }, 'STOCK_CREATE_GET_STOCK_BRAND_TYPES_METHODS')
    },
  },
}
</script>
